import { useSelector } from "react-redux";
import Location from "../features/rapidstor/entities/Location";
import { selectResponses } from "../store/questionnaireSlice";
import { useGetQuestionnaireQuery } from "../features/rapidstor/rapidstorApiSlice";
import { useLoaderData } from "react-router-dom";
import { useMemo } from "react";

export interface Filters {
  [key: string]: boolean | string | number;
}

export function useAppliedFilters() {
  const location = useLoaderData() as Location;
  const { data: questionnaire, isLoading } = useGetQuestionnaireQuery(
    location.locationCode
  );

  const responses = useSelector(selectResponses);

  // @TODO: clean up and extra this disaster of a blob
  const filters: Filters = useMemo(() => {
    const filters: Filters = {};
    if (questionnaire && responses) {
      for (const [questionId, answer] of Object.entries(responses)) {
        const question = questionnaire.questions[questionId];
        if (!question) {
          continue;
        }

        if (question.type === "multiple-choice") {
          const response = question.responses.find(
            (response) => response.answer === answer
          );
          for (const filter of response?.appliedFilters || []) {
            if (filter.type === "static") {
              filters[filter.field] = filter.value;
            }
          }
        } else if (question.type === "number") {
          for (const filter of question.appliedFilters || []) {
            if (filter.type === "dynamic") {
              filters[filter.field] = answer as ResponseType;
            }
          }
        } else if (question.type === "checkboxes") {
          for (const subResponse of answer as ResponseType[]) {
            const response = question.responses.find(
              (response) => response.answer === subResponse
            );

            for (const filter of response?.appliedFilters || []) {
              if (filter.type === "static") {
                if (
                  filter.operator === "add" ||
                  (!filter.operator && typeof filters[filter.field] === "number")
                ) {
                  filters[filter.field] =
                    (filter.value as number) + ((filters[filter.field] as number) || 0);
                } else if (filter.operator === "multiply" && filters[filter.field]) {
                  filters[filter.field] =
                    (filter.value as number) * (filters[filter.field] as number);
                } else {
                  filters[filter.field] = filter.value;
                }
              }
            }
          }
        }
      }
    }
    return filters;
  }, [questionnaire, responses]);

  return { filters, isLoading };
}
